import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var ArrowCircleBrokenDownRight = function ArrowCircleBrokenDownRight(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M9.4105 2.3394c3.3361-.8909 7.0433-.0277 9.6606 2.5896 3.9052 3.9052 3.9052 10.2369 0 14.1421-3.9053 3.9053-10.237 3.9053-14.1422 0-2.6173-2.6173-3.4804-6.3244-2.5895-9.6606M15 9.0001v6m0 0H9m6 0-10-10"
    })
  }));
};
export default ArrowCircleBrokenDownRight;